import * as globalStyles from "./GlobalStyles";

export const INVOICE = "invoice";
export const WORLD_LOADING_TYPE_FULL_PAGE = "WORLD_LOADING_TYPE_FULL_PAGE";
export const WORLD_LOADING_TYPE_NEXT_PAGE = "WORLD_LOADING_TYPE_NEXT_PAGE";
export const WORLD_LOADING_TYPE_REFRESH = "WORLD_LOADING_TYPE_REFRESH";

// Icon names w/ descriptions
export const ICON_NAMES = {
  BIRD: "bird",
  CLOSE: "close",
  CLOSE_THICK: "close-thick",
  LOCK: "lock",
  MARKUNREAD_MAILBOX: "markunread_mailbox",
  MAIL_OUTLINE: "mail_outline",
  ENVELOPE: "envelope",
  SHARE_SQUARE_O: "share-square-o",
  LOCATION_MARINA: "location-marina",
  NAVIGATION_MORE: "navigation-more",
  SEARCH: "search",
  HOME: "home",
  HOME2: "home3",
  OFFICE: "office",
  PENCIL: "pencil",
  QUILL: "quill",
  IMAGE: "image",
  IMAGES: "images",
  CAMERA: "camera",
  VIDEO_CAMERA: "video-camera",
  MIC: "mic",
  CART: "cart",
  ENVELOP: "envelop",
  LOCATION: "location",
  COMPASS: "compass2",
  MAP: "map",
  CLOCK: "clock",
  BUBBLES: "bubbles",
  BUBBLES2: "bubbles2",
  COG: "cog",
  GIFT: "gift",
  BIN: "bin",
  EARTH: "earth",
  FLAG: "flag",
  ATTACHMENT: "attachment",
  STAR: "star-full",
  HEART: "heart",
  PLUS: "plus",
  MINUS: "minus",
  CHECKMARK: "checkmark",
  PLAY: "play3",
  PAUSE: "pause2",
  STOP: "stop2",
  VOLUME_MEDIUM: "volume-medium",
  VOLUME_MUTE: "volume-mute2",
  ARROW_UP_LEFT: "arrow-up-left2",
  ARROW_UP: "arrow-up2",
  ARROW_UP_RIGHT: "arrow-up-right2",
  ARROW_RIGHT: "arrow-right2",
  ARROW_DOWN_RIGHT: "arrow-down-right2",
  ARROW_DOWN: "arrow-down2",
  ARROW_DOWN_LEFT: "arrow-down-left2",
  ARROW_LEFT: "arrow-left2",
  CHECKBOX_CHECKED: "checkbox-checked",
  CHECKBOX_UNCHECKED: "checkbox-unchecked",
};

// Types for component options
export const TEXT_TYPES = {
  TITLE: "title",
  GIANT_TITLE: "giantTitle",
  SMALL_TITLE: "smallTitle",
  TAB: "tab",
  SECTION_HEADER: "sectionHeader",
  SECTION_HEADER_SMALL: "sectionHeaderSmall",
  SECTION_HEADER_MEDIUM: "sectionHeaderMedium",
  SECTION_HEADER_LARGE: "sectionHeaderLarge",
  SECTION_HEADER_EXTRA_LARGE: "sectionHeaderExtraLarge",
  SECTION_HEADER_GODZILLA: "sectionHeaderGodzilla",
  ITEM_HEADER: "itemHeader",
  ITEM_HEADER_SMALL: "itemHeaderSmall",
  SUPER_HEADER: "superHeader",
  SUPER_HEADER_LARGE: "superHeaderLarge",
  SUPER_HEADER_EXTRA_LARGE: "superHeaderExtraLarge",
  SUPER_HEADER_GODZILLA: "superHeaderGodzilla",
  SUPER_HEADER_SUPER_GODZILLA: "superHeaderSuperGodzilla",
  DUMMY_LINK: "dummyLink",
  FAT_HIGHLIGHT: "fatHighlight",
  FAT_HIGHLIGHT_MEDIUM_LARGE: "fatHighlightMediumLarge",
  FAT_HIGHLIGHT_MEDIUM: "fatHighlightMedium",
  FAT_HIGHLIGHT_MEDIUM_SEMI: "fatHighlightMediumSemi",
  FAT_HIGHLIGHT_SMALL: "fatHighlightSmall",
  FAT_PRIMARY: "fatPrimary",
  BODY: "body",
  TALL_BODY: "tallBody",
  SMALL_BODY: "smallBody",
  MID_BODY: "midBody",
  BIG_BODY: "bigBody",
  GIANT_BODY: "giantBody",
  SMALL: "small",
  MINI: "mini",
  TINY: "tiny",
  SHARE_SHOT_MAIN: "shareShotMain",
  SHARE_SHOT_SECONDARY: "shareShotSecondary",
  SHARE_SHOT_TERTIARY: "shareShotTertiary",
  SHARE_SHOT_MONUMENT_MAIN: "shareShotMonumentMain",
  SHARE_SHOT_MONUMENT_SECONDARY: "shareShotMonumentSecondary",
  SHARE_SHOT_MONUMENT_TERTIARY: "shareShotMonumentTertiary",
  HEY_AUGUST_BODY: "heyAugustBody",
  HEY_AUGUST_HEADER: "heyAugustHeader",
  LIST_ITEM: "listItem",
  LIST_BOLD: "listBold",
  EXTERNAL_HYPERLINK: "externalHyperlink",
  AVENIR_TITLE: "avenirTitle",
  AVENIR_SUBTITLE: "avenirSubtitle",
};

export const REACTIONS = [
  { reactionType: "thumbsup", text: "👍" },
  { reactionType: "heart", text: "❤️" },
  { reactionType: "laugh", text: "😂" },
  { reactionType: "sad", text: "😢" },
  { reactionType: "praise", text: "🙌" },
];

export const IMAGE_TYPES = {
  CIRCLE: "circle",
  ROUNDED_SQUARE: "roundedSquare",
  VERY_ROUNDED_SQUARE: "veryRoundedSquare",
  LESS_ROUNDED_SQUARE: "lessRoundedSquare",
  HALF_ROUNDED: "halfRounded",
};

export const MESSAGE_TYPES = {
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
};

export const PASTEL_HEX_CODES = [
  "#a4b6dd",
  "#d09292",
  "#c094cc",
  "#a2d0c0",
  "#c37892",
  "#554994",
  "#f675a8",
  "#f29393",
  "#8b7e74",
];

export const HOUSES = [
  "small-grey",
  "small-red",
  "small-yellow",
  "mid-grey",
  "mid-red",
  "mid-purple",
  "tall-blue",
  "tall-red",
  "tall-purple",
];

export const MAP_STYLE = [
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#aee2e0",
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#abce83",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#769E72",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#7B8758",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#EBF4A4",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        visibility: "simplified",
      },
      {
        color: "#8dab68",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [
      {
        visibility: "simplified",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#5B5B3F",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#ABCE83",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [
      {
        color: "#A4C67D",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        color: "#9BBF72",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#EBF4A4",
      },
    ],
  },
  {
    featureType: "transit",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#87ae79",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#7f2200",
      },
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        visibility: "on",
      },
      {
        weight: 4.1,
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#495421",
      },
    ],
  },
  {
    featureType: "administrative.neighborhood",
    elementType: "labels",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
];
